"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useParentFilterTitles = void 0;
var tslib_1 = require("tslib");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var AttributeFilterUtils_1 = require("../../utils/AttributeFilterUtils");
var json_stable_stringify_1 = tslib_1.__importDefault(require("json-stable-stringify"));
/**
 * Fetches attribute titles for parent filters impacting the {@link AttributeFilterButton}.
 */
exports.useParentFilterTitles = function (props) {
    var context = props.context, ownProps = props.ownProps;
    return sdk_ui_1.useCancelablePromise({
        promise: function () { var _a; return AttributeFilterUtils_1.getParentFilterTitles((_a = ownProps.parentFilters) !== null && _a !== void 0 ? _a : [], context.backend, context.workspace); },
    }, [context.backend, context.workspace, json_stable_stringify_1.default(ownProps.parentFilters)]);
};
//# sourceMappingURL=useParentFilterTitles.js.map